import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NavHeaderComponent } from './nav-header.component';

@NgModule({
  declarations: [NavHeaderComponent],
  exports: [NavHeaderComponent],
  imports: [CommonModule, RouterModule]
})
export class NavHeaderModule {}
